export function formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
	try {
		decimalCount = Math.abs(decimalCount);
		decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

		const negativeSign = amount < 0 ? "-" : "";

		let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
		let j = (i.length > 3) ? i.length % 3 : 0;


		var result = negativeSign +
			(j ? i.substr(0, j) + thousands : '') +
			i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
			(decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");

		return result;
	} catch (e) {
		console.error(e)
	}
};

export const numberWithCommas = (x) => {
	if (x === null || x === undefined) return "";
	if (x === -1) return "-"
	//    int değer, binlikler . ile ayrılmalı
	return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
